function createListOfSupportArticles() {
  document.addEventListener("DOMContentLoaded", function () {
    const element = document.getElementById('hidden-support-posts-json');
    const hiddenJson = element.textContent.trim();
    element.remove();
    const metadata = JSON.parse(hiddenJson);
    const posts = metadata.posts;

    const uniqueAuthors = new Map();

    let articleCount = 0;
    const primaryPosts = [];
    const secondaryPosts = {};
    posts.forEach(post => {
      articleCount++;
      post.authors.forEach(author => {
        if (!uniqueAuthors.has(author.name)) {
          uniqueAuthors.set(author.name, author);
        }
      });

      const { tags } = post;

      if (tags?.length > 0) {
        tags.forEach(tag => {
          if (!secondaryPosts[tag.slug]) {
            secondaryPosts[tag.slug] = {
              tag,
              posts: []
            };
          }
          secondaryPosts[tag.slug].posts.push(post);
        });
      } else {
        // Only internal tag exists
        primaryPosts.push(post);
      }
    });

    // Get the element by its ID
    document.getElementById('support-articles-count').textContent = articleCount;

    const authorListEl = document.getElementById('support-articles-author-list');
    authorListEl.innerHTML = '';

    const authorArray = Array.from(uniqueAuthors.values());
    const authorImages = authorArray.map(author => author.profile_image);
    const firstAuthorName = authorArray[0]?.name;

    authorImages.forEach(img => {
      const authorEl = document.createElement('div');
      authorEl.classList.add('avatar');

      authorEl.innerHTML = `
        ${img ? `<img src="${img}" alt="" class="avatar-img" />` : ''}
      `;

      authorListEl.appendChild(authorEl);
    });

    const firstAuthorEl = document.createElement('p');
    firstAuthorEl.textContent = `By ${firstAuthorName}${authorImages.length > 1 ? ` and ${authorImages.length - 1} others` : ''}`;
    firstAuthorEl.classList.add('ml-1');
    firstAuthorEl.classList.add('p4--desktop');
    authorListEl.appendChild(firstAuthorEl);

    const container = document.getElementById('support-articles-post-list');

    function createPostItem(post) {
      return `
        <div class="article-item">
          <a href="${post.url}" class="button-base link medium full-width h-align-space-between">
            ${post.title}
            <span>
              <img src="/assets/images/icons/chevron-right.svg" alt="" />
            </span>
          </a>
        </div>
      `;
    }

    // Section: Posts with only primary tag (Variable A)
    if (primaryPosts.length > 0) {
      const primarySection = document.createElement('section');
      primarySection.innerHTML = `
        <div class="article-container mt-3 mb-3">
          ${primaryPosts.map(createPostItem).join("")}
        </div>
      `;
      container.appendChild(primarySection);
    }

    // Sections for each non-primary tag group (Variable B)
    Object.values(secondaryPosts).forEach(group => {
      const section = document.createElement('section');
      section.innerHTML = `
        <div class="article-container mt-3 mb-3">
          <h6 class="button-base link medium h6--desktop article-tag">${group.tag.name}</h6>
          ${group.posts.map(createPostItem).join("")}
        </div>
      `;
      container.appendChild(section);
    });
  });
}


function createListOfSupportArticleTags() {
  document.addEventListener("DOMContentLoaded", function () {
    const element = document.getElementById('hidden-support-posts-json');
    const hiddenJson = element.textContent.trim();
    element.remove();
    const metadata = JSON.parse(hiddenJson);
    const posts = metadata.posts;

    let tags = [];
    let mainPostCount = 0;
    posts.forEach(post => {
      if (!post?.tags?.length) {
        mainPostCount++;
      } else {
        post.tags.forEach(tag => {
          // Count how many posts have this tag
          if (!tags.some(t => t.slug === tag.slug)) {
            // Calculate post count for this tag
            const postCount = posts.filter(p => p.tags.some(t => t.slug === tag.slug)).length;
            tags.push({ ...tag, postCount });
          }
          mainPostCount++;
        });
      }
    });

    const container = document.getElementById('support-articles-tags');

    function createTagItem(tag) {
      return `
        <a href="${tag.link}" class="tag-item">
          <img src="${tag.feature_image}" alt="" class="tag-image" />
          <div>
            <p class="h5--desktop">${tag.name}</p>
            <p class="p3--desktop color-neutral-gray-3 mt-05">${tag.postCount} Articles</p>
          </div>
        </a>
      `;
    }

    const section = document.createElement('section');
    section.innerHTML = `
      <a href="${metadata.base_url}/support-articles" class="tag-item">
        <img src="${metadata.support_article_image}" alt="" class="tag-image" />
        <div>
          <p class="h5--desktop">Support Articles</p>
          <p class="p3--desktop color-neutral-gray-3 mt-05">${mainPostCount} Articles</p>
        </div>
      </a>
    `;
    container.appendChild(section);

    // Sections for each non-primary tag group (Variable B)
    tags.forEach(tag => {
      const section = document.createElement('section');
      section.innerHTML = `
        ${createTagItem(tag)}
      `;
      container.appendChild(section);
    });
  });
}
